import React, { Component } from 'react'
import { Form, Radio, Modal, Input, InputNumber } from 'antd'
import R from 'ramda'
import { cronToBasic, describeCron } from './utils'

const isEmpty = name => name == null || name.trim().length === 0

const validate = ({
  name,
  cron,
  // eslint-disable-next-line no-unused-vars
  cronExpression,
  hour,
  minute,
  mode,
  availableTriggers,
}) => {
  return {
    name: isEmpty(name)
      ? 'Trigger name must be provided'
      : R.any(t => t.name === name, availableTriggers)
      ? 'There is already another trigger with this name'
      : null,
    hour:
      mode === 'basic'
        ? isEmpty(hour)
          ? 'Hour must be provided'
          : !cron.success
          ? true
          : undefined
        : undefined,
    minute:
      mode === 'basic'
        ? isEmpty(minute)
          ? 'Minute must be provided'
          : !cron.success
          ? true
          : undefined
        : undefined,
    cronExpression: !cron.success
      ? (mode === 'basic'
          ? 'Hour or Minute Error: '
          : 'Cron Expression Error: ') + cron.description
      : undefined,
  }
}

const isInValid = R.compose(
  R.any(([_, v]) => v != null),
  R.toPairs
)
const defaultCron = '0 0 0 * * ?'
const defaultState = {
  name: '',
  cronExpression: defaultCron,
  mode: 'basic',
  hour: '0',
  minute: '0',
  validation: {},
  cron: describeCron(defaultCron),
}

class TriggerAdderModal extends Component {
  state = {
    ...defaultState,
    validation: validate({
      ...defaultState,
      availableTriggers: this.props.availableTriggers || [],
    }),
  }

  static defaultProps = { availableTriggers: [] }

  toCron = _ => this.setState({ mode: 'cron' })

  toBasic = _ =>
    this.setState(({ cronExpression, cron }) => ({
      mode: 'basic',
      cronExpression: cron.success ? cronToBasic(cronExpression) : defaultCron,
    }))

  dataChanged = e => {
    const { name, value } = e.target

    this.setState(state => {
      const newState = { ...state, [name]: value, edited: true }
      const { minute, hour } = newState
      const cronExpression =
        newState.mode === 'basic'
          ? `0 ${minute == null ? '0' : minute} ${
              hour == null ? '0' : hour
            } * * ?`
          : newState.cronExpression
      const cron = describeCron(cronExpression)
      const nd = {
        ...newState,
        cronExpression,
        cron,
        validation: validate({
          ...newState,
          cronExpression,
          cron,
          availableTriggers: this.props.availableTriggers,
        }),
      }
      return nd
    })
  }

  saveData = () => {
    const { name, cronExpression, validation } = this.state
    const { setError } = this.props
    if (!isInValid(validation)) {
      const { save } = this.props
      if (save) {
        save({
          name,
          triggerType: 'CRON',
          cronExpression: cronExpression,
        }).fork(
          e => setError(e, this.props.close),
          _ => _
        )
      }
    }
  }

  render() {
    const {
      name,
      cron,
      cronExpression,
      mode,
      hour,
      minute,
      validation,
    } = this.state

    return (
      <Modal
        title="New Trigger"
        visible
        onOk={this.saveData}
        okText="Add Trigger"
        onCancel={this.props.close}
        // footer={<div>
        //   <Button onClick={this.props.close}>Cancel</Button>
        //   <Button primary onClick={this.saveData}>
        //     Add Trigger
        //   </Button>
        // </div>}
      >
        <Form size="small">
          <Form.Item
            //  control={Input}
            label="Trigger Name"
            value={name}
            name="name"
            error={validation.name != null}
            style={{ margin: '0px' }}
          >
            <Input onChange={this.dataChanged} name="name" value={name} />
          </Form.Item>

          {mode === 'basic' && (
            <div style={{ display: 'flex', columnGap: '10px' }}>
              <Form.Item
                style={{ margin: '0px' }}
                name="hour"
                // control={Input}
                label="Hour"
                error={validation.hour != null}
                value={hour}
              >
                <InputNumber
                  max={23}
                  min={0}
                  style={{ width: '100%' }}
                  onChange={value =>
                    this.dataChanged({
                      target: { name: 'hour', value: '' + value },
                    })
                  }
                  value={hour}
                />
              </Form.Item>
              <Form.Item
                name="minute"
                // control={Input}
                label="Minute"
                error={validation.minute != null}
                value={minute}
                style={{ margin: '0px' }}
              >
                <InputNumber
                  max={59}
                  min={0}
                  style={{ width: '100%' }}
                  onChange={value =>
                    this.dataChanged({
                      target: { name: 'minute', value: '' + value },
                    })
                  }
                  value={minute}
                />
              </Form.Item>
            </div>
          )}

          {mode === 'cron' && (
            <Form.Item
              style={{ margin: '0px' }}
              // control={Input}
              name="cronExpression"
              error={validation.cronExpression != null}
              label="Cron Expression"
              value={cronExpression}
            >
              <Input
                onChange={this.dataChanged}
                value={cronExpression}
                name="cronExpression"
              />
            </Form.Item>
          )}
          {cron.success && (
            <Form.Item style={{ margin: '0px' }}>
              <div style={{ fontWeight: 'bold' }}>{cron.description}</div>
            </Form.Item>
          )}
          <Form.Item style={{ margin: '0px' }}>
            <Radio.Group>
              <Radio.Button
                onClick={this.toBasic}
                style={{
                  backgroundColor: mode === 'basic' ? 'black' : undefined,
                  color: mode === 'basic' ? 'white' : undefined,
                }}
              >
                Basic
              </Radio.Button>
              <Radio.Button
                onClick={this.toCron}
                style={{
                  backgroundColor: mode === 'cron' ? 'black' : undefined,
                  color: mode === 'cron' ? 'white' : undefined,
                }}
              >
                Cron*
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Form>
        {isInValid(validation) && (
          <div
            style={{
              backgroundColor: '#fff6f6',
              padding: '10px',
              border: '1px solid #bfbfbf',
              minWidth: '100px',
            }}
          >
            <div>Please correct the following errors before continuing</div>
            <ul>
              {Object.values(validation)
                .filter(v => typeof v === 'string')
                .map(d => (
                  <li key={d}>{d}</li>
                ))}
            </ul>
          </div>
        )}
        {/* {isInValid(validation) &&
          Modal.error({
            title: 'Please correct the following errors before continuing',
            content: Object.values(validation).filter(
              v => typeof v === 'string'
            ),
          })} */}
      </Modal>
    )
  }
}

export default TriggerAdderModal
